import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { boolean, object, string } from "yup";
import { ModeFormValues } from "src/models/Mode.model";
import ModeForm from "../Layouts/ModeForm";
import {
  useEditModeMutation,
  useViewModeQuery,
} from "src/services/ModeServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
type Props = {
  onClose: () => void;
  modeId: string;
};

const EditModeFormWrapper = ({ onClose, modeId }: Props) => {
  //State
  const [modeData, setModeData] = useState<any>();

  // API
  const [editMode] = useEditModeMutation();

  const { data, isLoading, isFetching } = useViewModeQuery(modeId);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setModeData(data?.data);
    }
  }, [isFetching, isLoading, data]);

  // Form Initial Values
  const initialValues: ModeFormValues = {
    modeName: modeData?.modeName,
    modeDescription: modeData?.modeDescription,
    isVirtual: modeData?.isVirtual,
  };

  // Validation Schema
  const validationSchema = object().shape({
    modeName: string().required("Please enter name"),
    modeDescription: string().required("Please enter description"),
    isVirtual: boolean().required("Required"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ModeFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ModeFormValues>
  ) => {
    editMode({
      body: values,
      id: modeId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ModeForm
              formType="EDIT"
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditModeFormWrapper;
